import { Spinner } from 'react-bootstrap'
import { createUseStyles } from 'react-jss'
import { Colors } from '../constants/colors'
import FullScreenModal from './FullScreenModal'

interface Props {
    visible: boolean
    message?: string
}

const FullScreenLoadingIndicator = ({visible, message} : Props) => {
    const styles = useStyles()

    return (
        <FullScreenModal visible={visible}>
            <Spinner
                as='span'
                animation='border'
            />
            {message && <p className={styles.message}>{message}</p>}
        </FullScreenModal>
    )
}

export default FullScreenLoadingIndicator

const useStyles = createUseStyles({
    message: {
        marginTop: 15,
        maxWidth: 320,
        textAlign: 'center',
        color: Colors.white
    }
})
